/* eslint-disable */
import React from "react";
import Modal from "react-modal";
import { overlayModalStyle } from "../../helpers/ui-helper";

const LeaveChallengeConfirmationModal = ({
  isOpen,
  closeModal,
  challengeName,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      style={overlayModalStyle}
      className="challenge-modal-dialog small"
    >
      <div className="challenge-modal-content">
        <button
          className="challenge-modal_close"
          onClick={closeModal}
          aria-label="Close"
        >
          ✕
        </button>
        <div
          className="challenge-modal-body"
          style={{ maxWidth: "85%", margin: "30px auto 0" }}
        >
          <div className="warning-icon-container">
            <div className="warning-icon">
              <i className="material-icons-outlined">warning_amber_icon</i>
            </div>
          </div>
          <h3
            style={{
              fontSize: "24px",
              fontWeight: "600",
              textAlign: "center",
              color: "#000",
            }}
          >
            {`Are you sure you want to leave the ${challengeName}?`}
          </h3>
          <p
            style={{
              fontSize: "18px",
              textAlign: "center",
              color: "#475467",
              fontWeight: "500",
              padding: "10px",
            }}
          >
            Your scores will be removed from the leaderboard and you'll no
            longer be able to post scores to the Challenge.
          </p>
          <div className="actions centered">
            <button
              className="btn fill cardinal"
              style={{
                maxWidth: "85%",
                width: "85%",
                height: "41px",
                display: "flex",
                justifyContent: "center",
                fontSize: "17px",
              }}
              onClick={onConfirm}
            >
              LEAVE CHALLENGE
            </button>
            <button
              className="btn outline blue"
              style={{
                borderRadius: "20px",
                maxWidth: "85%",
                width: "85%",
                fontSize: "17px",
              }}
              onClick={closeModal}
            >
              NEVERMIND
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LeaveChallengeConfirmationModal;
